import { Locale } from '@headless-workspace/config';
import { ImageWithSrc } from '@headless-workspace/typings';

const numberOfKeys = (value: object): number => {
    return Object.keys(value).length;
};

const isEmpty = (value?: object): boolean => {
    return !value || numberOfKeys(value) === 0;
};

const createImageWithSrc = (src: string, alt = ''): ImageWithSrc => {
    return {
        src,
        alt,
    };
};

const mapObject = <T, U>(
    object: Record<string, T>,
    mapFn: (value: T, locale?: Locale) => U,
    locale?: Locale,
): Record<string, U> => {
    return Object.keys(object).reduce(
        (acc, key) => {
            acc[key] = mapFn(object[key], locale);
            return acc;
        },
        {} as Record<string, U>,
    );
};

const isEnumValue = <T extends Record<string, string>>(value: string, enumObj: T): value is T[keyof T] => {
    return Object.values(enumObj).includes(value as T[keyof T]);
};

const isNotNullishGuard = <T>(value: T | null | undefined): value is T => {
    return Boolean(value);
};

const flatObjectArray = <T extends Record<string, unknown> | undefined>(object: T[]): T => {
    return object.reduce<T>((acc, current) => {
        return { ...acc, ...current };
    }, {} as T);
};

export const ObjectHelpers = {
    numberOfKeys,
    isEmpty,
    createImageWithSrc,
    mapObject,
    isEnumValue,
    isNotNullishGuard,
    flatObjectArray,
};
